import React, { useState } from "react";
import { UserType } from "../types/user-types";
import { MdDeleteSweep } from "react-icons/md";
import axiosInstance from "../utils/axios-instance";
import { toast } from "sonner";
import { MdEdit } from "react-icons/md";

const UserList = ({ users, onDeleteSuccess }) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState({ id: null, name: "" });
    const [selectedEditUser, setSelectedEditUser] = useState({ id: '', name: '', userType: '' });
    const [showRoleModal, setShowRoleModal] = useState(false);
    const [selectedRole, setSelectedRole] = useState('');

    const getUserTypeLabel = (type) => {
        switch (type) {
            case UserType.ADMIN:
                return "Admin";
            case UserType.FACILITATOR:
                return "Facilitator";
            case UserType.USER:
                return "User";
            default:
                return "Unknown";
        }
    };

    const handleEditRoleClick = (user) => {
        setSelectedEditUser({ id: user.id, name: user.fullName, userType: user.userType });
        setSelectedRole(user.userType);
        setShowRoleModal(true);
    };

    const handleDeleteClick = (id, name) => {
        setSelectedUser({ id, name });
        setShowModal(true);
    };

    const handleConfirmDelete = async () => {
        try {
            const res = await axiosInstance.delete(`/user/deleteuser?id=${selectedUser.id}`);
            if (res.status === 200) {
                toast.success(`${selectedUser.name} deleted successfully`);
                onDeleteSuccess(selectedUser.id);
                setShowModal(false);
                setSelectedUser({ id: null, name: "" });
            }

        } catch (error) {
            toast.error("Failed to delete user");
        }
    };

    const handleRoleSubmit = async () => {
        const dataToSend = {id: selectedEditUser.id, userType: selectedRole};   

         try {
              const res = await axiosInstance.post('/user/assignuserrole', dataToSend);
              if (res.status === 200) {
                toast.success(res.data.message);
              } else {
                toast.error(res.data.message);
              }
            } catch (error) {
              toast.error(error.response.data.message);
            } finally {
               setShowRoleModal(false);
            }

    };


    return (
        <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300 text-sm text-left">
                <thead className="bg-gray-100">
                    <tr>
                        <th className="px-4 py-2 border">S/N</th>
                        <th className="px-4 py-2 border">Full Name</th>
                        <th className="px-4 py-2 border">Email</th>
                        <th className="px-4 py-2 border">User Type</th>
                        <th className="px-4 py-2 border">Created At</th>
                        <th className="px-4 py-2 border">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {users?.map((user, index) => (
                        <tr key={user.id} className="hover:bg-gray-50">
                            <td className="px-4 py-2 border">{index + 1}</td>
                            <td className="px-4 py-2 border">{user.fullName}</td>
                            <td className="px-4 py-2 border">{user.email}</td>
                            <td className="px-4 py-2 border">{getUserTypeLabel(user.userType)}</td>
                            <td className="px-4 py-2 border">
                                {new Date(user.createdAt).toLocaleString()}
                            </td>
                            <td className="px-4 py-2 border flex justify-center space-x-2">
                                <button
                                    onClick={() => handleEditRoleClick(user)}
                                    className="p-2 rounded-md bg-blue-500 text-white"
                                    aria-label="Edit role"
                                >
                                    <MdEdit className="h-5 w-5" />
                                </button>
                                <button
                                    onClick={() => handleDeleteClick(user.id, user.fullName)}
                                    className="p-2 rounded-md bg-red-500 text-white"
                                    aria-label="Delete user"
                                >
                                    <MdDeleteSweep className="h-5 w-5" />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>



            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded shadow-md w-[300px] text-center">
                        <p className="mb-4 text-lg font-medium">
                            Are you sure you want to delete <span className="font-bold">{selectedUser.name || 'this user'}</span>?
                        </p>
                        <div className="flex justify-center gap-4">
                            <button
                                className="bg-gray-300 px-4 py-2 rounded"
                                onClick={() => setShowModal(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="bg-red-600 text-white px-4 py-2 rounded"
                                onClick={handleConfirmDelete}
                            >
                                Yes, Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}




            {/* Edit Role Modal */}
            {showRoleModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded shadow-md w-[300px]">
                        <h3 className="text-lg font-medium mb-4">Edit User Role</h3>
                        <p className="mb-4">
                            Change role for <span className="font-bold">{selectedEditUser.name}</span>
                        </p>
                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Select Role
                            </label>
                            <select
                                className="w-full p-2 border rounded"
                                value={selectedRole}
                                onChange={(e) => setSelectedRole(e.target.value)}
                            >
                                <option value={UserType.ADMIN}>Admin</option>
                                <option value={UserType.FACILITATOR}>Facilitator</option>
                                <option value={UserType.USER}>User</option>
                            </select>
                        </div>
                        <div className="flex justify-end gap-4">
                            <button
                                className="bg-gray-300 px-4 py-2 rounded"
                                onClick={() => setShowRoleModal(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="bg-blue-600 text-white px-4 py-2 rounded"
                                onClick={handleRoleSubmit}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default UserList;
